import { render, staticRenderFns } from "./companyPriceSetPass.vue?vue&type=template&id=f71bb9aa&scoped=true"
import script from "./companyPriceSetPass.vue?vue&type=script&lang=js"
export * from "./companyPriceSetPass.vue?vue&type=script&lang=js"
import style0 from "./companyPriceSetPass.vue?vue&type=style&index=0&id=f71bb9aa&prod&scoped=true&lang=css"
import style1 from "./companyPriceSetPass.vue?vue&type=style&index=1&id=f71bb9aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71bb9aa",
  null
  
)

export default component.exports